import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { observer, useLocalStore } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { SyncLoader } from 'react-spinners';
import { DatePicker } from '@patternfly/react-core';
import { parseReportDate } from 'components/Reports/parseReportDate';
import ErrorMessage from '../../Error/ComponentError';
import { handleError } from '../../../services/ErrorService';
import ExpiringSubscriptionsReportStore from './store';
import './styles.scss';

const ExpiringSubscriptionsReport = () => {
  const { t } = useTranslation();
  const store = useLocalStore(() => new ExpiringSubscriptionsReportStore());

  const generateReport = async () => {
    store.fetchReport();
  };
  return (
    <article className="expiring-subscriptions-report-wrapper">
      {store.errorMsgVisible && (
        <Alert bsStyle="danger">
          {t(`Couldn't fetch the expiring subscription report:`)}&nbsp;
          {t(store.errorMessage)}
        </Alert>
      )}
      <Form onSubmit={generateReport}>
        <h4 className="input-bar-header">
          {t('Find subscriptions expiring between:')}
        </h4>
        <FormGroup id="expiring-subscription-inputs">
          <div>
            <ControlLabel>{t('From')}</ControlLabel>
            <DatePicker
              value={store.startDateText || ''}
              placeholder={t('Enter start date')}
              onChange={(_event, value, date) => {
                const formattedDate = parseReportDate(value, date);
                store.startDateText = formattedDate || value || undefined;
                store.startDate = formattedDate;
              }}
            />
          </div>
          <div>
            <ControlLabel>{t('To')}</ControlLabel>
            <DatePicker
              value={store.endDateText || ''}
              placeholder={t('Enter end date')}
              onChange={(_event, value, date) => {
                const formattedDate = parseReportDate(value, date);
                store.endDateText = formattedDate || value || undefined;
                store.endDate = formattedDate;
              }}
            />
          </div>
          <div className="submit-btn-container">
            <Button
              bsStyle="primary"
              onClick={generateReport}
              disabled={store.loading}
            >
              {store.loading ? (
                <div className="loading">
                  <SyncLoader loading={store.loading} color="white" size={10} />
                </div>
              ) : (
                t('Generate a report')
              )}
            </Button>
          </div>
        </FormGroup>
      </Form>
      {store.successMsgVisible && (
        <Alert bsStyle="success">
          {t('Report generated. Please check your downloads.')}
        </Alert>
      )}
    </article>
  );
};

export default withErrorBoundary(
  observer(ExpiringSubscriptionsReport),
  ErrorMessage,
  handleError,
);
